module.exports = __webpack_public_path__ + "static/assets/a086ea630cae7f852bf434e86a1d8eb8.svg";